/**
 * @generated SignedSource<<8e4ee3f6ef8dd61fa181a75d32ff9cd2>>
 * @relayHash 27144a0bed02bf89bd05934de4bc8547
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ConfluenceUpdateContentApprovalRequestInput = {
  approvalStatus?: ConfluenceWorkflowReviewStatus | null | undefined;
  comment?: string | null | undefined;
  contentApprovalReviewId: AGG$Long;
  reviewers?: ReadonlyArray<ConfluenceContentApprovalReviewerInput | null | undefined> | null | undefined;
  workflowApplicationId: AGG$Long;
};
export type ConfluenceContentApprovalReviewerInput = {
  isRequired?: boolean | null | undefined;
  principalId: string;
  principalType: ConfluencePrincipalType;
};
export type ApprovalsContextUpdateWorkflowReviewMutation$variables = {
  cloudId: string;
  updateContentApprovalGraphQLInput: ConfluenceUpdateContentApprovalRequestInput;
};
export type ApprovalsContextUpdateWorkflowReviewMutation$data = {
  readonly confluence_updateContentApproval: {
    readonly contentApproval: {
      readonly comment: string | null | undefined;
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewers: ReadonlyArray<{
        readonly isRequired: boolean;
        readonly principalId: string;
        readonly principalType: string;
        readonly user: {
          readonly displayName: string | null | undefined;
          readonly emails: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly id: string | null | undefined;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type ApprovalsContextUpdateWorkflowReviewMutation = {
  response: ApprovalsContextUpdateWorkflowReviewMutation$data;
  variables: ApprovalsContextUpdateWorkflowReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updateContentApprovalGraphQLInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "updateContentApprovalGraphQLInput",
    "variableName": "updateContentApprovalGraphQLInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v8 = {
  "concreteType": "ConfluenceWorkflowReview",
  "kind": "LinkedField",
  "name": "contentApproval",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewStatus"
    },
    {
      "kind": "ScalarField",
      "name": "comment"
    },
    {
      "concreteType": "ConfluenceWorkflowReviewer",
      "kind": "LinkedField",
      "name": "reviewers",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "principalType"
        },
        {
          "kind": "ScalarField",
          "name": "principalId"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "displayName"
            },
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": (v7/*: any*/)
            },
            {
              "concreteType": "AtlassianUserEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": (v7/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextUpdateWorkflowReviewMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentApprovalPayload",
        "kind": "LinkedField",
        "name": "confluence_updateContentApproval",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          (v8/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextUpdateWorkflowReviewMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentApprovalPayload",
        "kind": "LinkedField",
        "name": "confluence_updateContentApproval",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "27144a0bed02bf89bd05934de4bc8547",
    "id": "b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1",
    "metadata": {},
    "name": "ApprovalsContextUpdateWorkflowReviewMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsContextUpdateWorkflowReviewMutation($cloudId:ID!,$updateContentApprovalGraphQLInput:ConfluenceUpdateContentApprovalRequestInput!){confluence_updateContentApproval(cloudId:$cloudId,updateContentApprovalGraphQLInput:$updateContentApprovalGraphQLInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "6e686f80296d6e3ef707726180b7464e";

export default node;
